import React, { useState, useEffect } from "react";
import { useParams,Link,useNavigate } from 'react-router-dom';
import axios from 'axios';

import DatePicker from "react-datepicker";
/* import { ko } from 'date-fns/esm/locale'; */
import "react-datepicker/dist/react-datepicker.css";

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

import Header from "../../components/includes/Header";
import SettlementLines from "../../components/settlements/SettlementLines";
import {addThousandPoint, ChangeDateFormat,isNull, removeThousandPoint} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

//매출세부정보
export const SettlementDetail = () => {
  let { st_idx,terms } = useParams();
  const navigate = useNavigate();

  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);

  const [varSettlementData,setSettlementData] = useState({});
  const [varSettlementRoyaltyList,setSettlementRoyaltyList] = useState([]);
  const [varSettlementOtherList,setSettlementOtherList] = useState([]);
  const [varSettlementSerious,setSettlementSerious] = useState([]);
  const [varSettlementTitle,setSettlementTitle] = useState("정산 요청서 작성");

  //센터 목록
  const [varBranchList,setBranchList] = useState([]);
  //검색년도
  const [varYearList, setYearList] = useState([]);
  //검색월
  const [varMonthList, setMonthList] = useState([]);
  //정산 계산 금액 객체
  const [varSettlementInfo,setSettlementInfo] = useState({});
  //입금일자
  const [varInsMoneyDate,setInsMoneyDate] = useState(null);
  //정산에 필요한 정보를 호출
  const [varCallSettlement,setCallSettlement] = useState(false);

  //센터 정보 호출
  const GetSettlementInformation = async() => {
    const sendData = {st_idx:st_idx,terms:terms};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_settlement_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const dataInfo = datas.results;
        const dataList = datas.settlements;

        //정산세부정보 내역
        const newSettlements = {royaltyAmount:0,otherAmount:0,totalAmount:0};
        if(dataList.length > 0) {
          //상시로열티
          const royaltyList = dataList.filter(el=>el.stl_vs_idx <= 2);
          setSettlementRoyaltyList(royaltyList);
          let royaltyAmount = 0;
          for(let i = 0; i < royaltyList.length; i++) {
            let royaltyData = royaltyList[i];
            royaltyAmount += (royaltyData.stl_numb * royaltyData.stl_price);
          }
          newSettlements.royaltyAmount = royaltyAmount;

          //수시로열티
          const otherList = dataList.filter(el=>el.stl_vs_idx > 2);
          let otherAmount = 0;
          for(let i = 0; i < otherList.length; i++) {
            let otherData = otherList[i];
            otherData.index = i;
            if(otherData.stl_vs_idx === 3) otherAmount += otherData.stl_amount;
            else otherAmount += (otherData.stl_numb * otherData.stl_price);
          }
          setSettlementOtherList(otherList);
          newSettlements.otherAmount = otherAmount;

          //합계
          newSettlements.totalAmount = royaltyAmount+otherAmount;
        }
        //console.log(newSettlements);
        setSettlementInfo(newSettlements);

        //정산내역정보
        if(dataInfo.length === 0){
          const ndate = new Date(terms+'-01');
          const nYear = ndate.getFullYear();
          const nMonth = ndate.getMonth()+1;
          const newItem = {st_idx:0,st_bh_idx:0,st_year:nYear,st_month:nMonth,st_income:0,st_amount:newSettlements.totalAmount,st_rdate:null,st_fdate:null,st_status:2};
          setSettlementData(newItem);
        } else {
          //입금일자
          let idate = "";
          if(!isNull(dataInfo[0].st_fdate)) idate = new Date(dataInfo[0].st_fdate);
          setInsMoneyDate(idate);
          setSettlementData(dataInfo[0]);
        } 

        //센터목록
        setBranchList(datas.branchs);
        //정산세부항목목록
        setSettlementSerious(datas.settlementserious);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setAdminMenus({type:'SETTLEMENT',item:'Settlement'});
    console.log(varAdminMenus);

    const ndate = new Date();
    //년도배열
    const nYear = ndate.getFullYear();
    let ayears = [];
    for(var i=0; i <10; i++) {
      ayears.push(nYear-i);
    }
    setYearList(ayears);

    //월배열
    let amonth = [];
    for(var j=1; j <12; j++) {
      amonth.push(j);
    }
    setMonthList(amonth);
    
    if(Number(st_idx) > 0) setSettlementTitle("정산 상세 수정");
  
    GetSettlementInformation();     
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //수시로얄티 금액변동시
  useEffect(() => {
    console.log(varSettlementOtherList);
    if(varSettlementOtherList.length > 0) {
      let otherAmount = 0;
      for(let i = 0; i < varSettlementOtherList.length; i++) {
        let otherData = varSettlementOtherList[i];
        console.log(varSettlementOtherList[i]);
        if(otherData.stl_status === 1) otherAmount += otherData.stl_amount;
      }
      console.log(varSettlementInfo.royaltyAmount,otherAmount);
      let totalAmount = varSettlementInfo.royaltyAmount + otherAmount;
      setSettlementInfo({...varSettlementInfo,otherAmount:otherAmount,totalAmount:totalAmount});
      setSettlementData({...varSettlementData,st_amount:totalAmount});
    } else {
      setSettlementInfo({...varSettlementInfo,otherAmount:0,totalAmount:varSettlementInfo.royaltyAmount});
      setSettlementData({...varSettlementData,st_amount:varSettlementInfo.royaltyAmount});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[varSettlementOtherList]);

  //신규등록시 종재유무 확인
  useEffect(() => {
    if(Number(st_idx) === 0) {
      if(varSettlementData.st_bh_idx > 0 && varSettlementData.st_year > 0 && varSettlementData.st_month > 0){
        CheckSettlementAlready();
      } 
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[varSettlementData.st_bh_idx,varSettlementData.st_year,varSettlementData.st_month]);

  const CheckSettlementAlready = async() => {
    const sendData = {dataInfo:varSettlementData};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_check_settlement_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue !== 1) {
        alert(datas.message);
      }
    });
  }

  //센터 선택
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === 'st_bh_idx' || name === 'st_year' || name === 'st_month'){
      setCallSettlement(false);
      setSettlementData({...varSettlementData,[name]:Number(value)});
    } else if(name === "st_income") {
      let svalue = removeThousandPoint(value);
      setSettlementData({...varSettlementData,[name]:svalue});
    } else {
      setSettlementData({...varSettlementData,[name]:Number(value)});
    }
  }

  //수시 로열티 추가
  const onAddSettlementLineHandler = (e) => {
    const findIndex = varSettlementOtherList.findIndex(el=>el.stl_status===0 && el.stl_idx === -1);
    if(findIndex > -1) {
      alert('먼저 추가된 수시로열티 항목을 저장하신 후에 추가하세요.'); return false;
    }
    const newIndex = varSettlementOtherList.length;
    const newItems = {index:newIndex,stl_idx:0,st_idx:Number(st_idx),stl_vs_idx:0,stl_info:'',stl_numb:0,stl_price:0,stl_amount:0,stl_sdate:null,stl_status:-1};
    setSettlementOtherList(varSettlementOtherList.concat(newItems));
  }

  //정산 내역 저장
  const onUpdateSettlementHandler = async(e) => {
    if(varSettlementData.st_bh_idx === 0) {
      alert('센터를 먼저 선택하세요.'); return false;
    } else if(varSettlementData.st_year === 0) {
      alert('정산할 년도를 먼저 선택하세요.'); return false;
    } else if(varSettlementData.st_month === 0) {
      alert('정산할 월을 먼저 선택하세요.'); return false;
    }
    //console.log(st_idx,varSettlementData,varSettlementRoyaltyList,varSettlementOtherList);
    if(!window.confirm('정산내역을 저장하시겠습니까?')) return false;

    const sendData = {st_idx:st_idx,dataInfo:varSettlementData};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_settlement_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        UpdateSettlementList(datas.st_idx);
      } else {
        alert(datas.message);
      }
    });
  }

  const UpdateSettlementList = async(st_idx2) => {
    const sendData = {st_idx:st_idx2,royaltyList:varSettlementRoyaltyList,dataList:varSettlementOtherList};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_settlement_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(Number(st_idx) === 0) SendPushMessage(st_idx2);
        alert('정산 요청서가 저장되었습니다.');
        navigate('/Admin/SettlementList');
      }
    });
  }
  
  //푸시보내기
  const SendPushMessage = async (st_idx2) => {
    const pushTitle = "[마마몽떼] 정산신청이 완료되었습니다.";
    const pushMessage = `${varSettlementData.st_year}.${varSettlementData.st_month}의 정산내역을 확인하시기 바랍니다.`;
    const pushUrl = `${process.env.REACT_APP_WEB_URL}/Branch/SettlementDetail/${st_idx2}`;
    const sendData = {mode:2,oppIdx:varSettlementData.st_bh_idx,pushTitle:pushTitle,pushMessage:pushMessage,pushUrl:pushUrl};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_push_single_message`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
    });
  }

  //상시 로얄티 내역보기
  const [varShowRoyaltyList,setShowRoyaltyList] = useState(false);
  const onShowRoyaltyListHandler = async(e) => {
    if(varSettlementData.st_bh_idx === 0) {
      alert('정산할 센터를 먼저 선택하세요.'); return false;
    }
    //console.log(st_idx,varCallSettlement);
    if(!varCallSettlement) {
      //해당 센터,년월에 해당하는 정산자료 호출
      const sendData = {st_bh_idx:varSettlementData.st_bh_idx,terms:`${varSettlementData.st_year}-${varSettlementData.st_month}`};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/_make_settlement_list`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          //결제완료정보 --> 정산내역에 없으면 --> 정산 내역에 추가
          const payments = datas.royaltys;
          let ramount = varSettlementInfo.royaltyAmount;
          let tamount = varSettlementInfo.totalAmount;
          
          let stlList = [];
          if(payments.length > 0) {
            for(var j=0; j < payments.length; j++) {
              let paids = payments[j];
              let ifind = false;
              for(var k=0; k < varSettlementRoyaltyList.length; k++) {
                let stlData = varSettlementRoyaltyList[k];
                if(paids.stl_ph_idx === stlData.stl_ph_idx) {
                  ifind = true;
                  break;
                }
              }
              //정산목록에 없으면 ---> 정산목록에 추가
              if(!ifind) {
                ramount += paids.stl_amount;
                tamount += paids.stl_amount;
                stlList.push(paids);
              }
            }
            setSettlementInfo({...varSettlementInfo,royaltyAmount:ramount,totalAmount:tamount});
          }
          setSettlementRoyaltyList(varSettlementRoyaltyList.concat(stlList));
          //검색한 로열티 저장????
          setShowRoyaltyList(true);
        } else {
          alert(datas.message);
        }
      }); 
    } else {
      setShowRoyaltyList(true);
    }
  }
  //검색기간 설정값 저장
  const onChangeDateHandler = (date) => {
    if(date === "" ) date = null;
    const st_fdate = ChangeDateFormat(date);
    setSettlementData({...varSettlementData,st_fdate:st_fdate});
    setInsMoneyDate(date);
  }

  return (
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={varSettlementTitle} varDirection={varSettlementTitle}/>
        <div className="admin-content">
          <div className="main-box">
            <table className="write">
              <colgroup><col width="30%"></col><col width="30%"></col><col width="40%"></col></colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>센터 선택</th>
                  <td>
                    {Number(st_idx)>0?varSettlementData.bh_company:
                      <select name="st_bh_idx" value={varSettlementData.st_bh_idx||0} style={{width:"150px"}} onChange={(e)=>onChangeInputHandler(e)}>
                        <option value={0}>센터 선택</option>
                        {varBranchList.map((branchs,i)=>(
                          <option key={'branchs_'+i} value={branchs.bh_idx}>{branchs.bh_company}</option>
                        ))}
                      </select>
                    }
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>청구월 선택</th>
                  <td colSpan={2}>
                    {Number(st_idx)>0?`${varSettlementData.st_year}.${varSettlementData.st_month}`:
                      <>
                        <select name="st_year" value={varSettlementData.st_year||0} style={{width:"90px"}} onChange={(e)=>onChangeInputHandler(e)}>
                          <option value={0}>년도 전체</option>
                          {varYearList.map((years,i)=>(
                            <option key={'years_'+i} value={years}>{years}</option>
                          ))}
                        </select>&nbsp;&nbsp;
                        <select  name="st_month" value={varSettlementData.st_month||0} style={{width:"90px"}} onChange={(e)=>onChangeInputHandler(e)}>
                          <option value={0}>월 전체</option>
                          {varMonthList.map((months,i)=>(
                            <option key={'months_'+i} value={months}>{months}</option>
                          ))}
                        </select>&nbsp;&nbsp;
                      </>
                    }
                  </td>
                </tr>
                <tr>
                  <th>월별 상시 로열티</th>
                  <td><input type="text" name="otherAmount" style={{width:"150px",backgroundColor:"#eee"}} value={addThousandPoint(varSettlementInfo.royaltyAmount)} disabled/></td> 
                  <td>
                    <span style={{cursor:"pointer",color:"blue"}} onClick={e=>onShowRoyaltyListHandler(e)}>
                      {!varCallSettlement?"[해당월 정산 관련 로얄티 호출]":"[월별 상시 로열티  세부 확인]"}
                    </span>
                  </td> 
                </tr>
                {!varShowRoyaltyList?null:
                  <tr>
                    <th>상시 로열티 <button onClick={()=>setShowRoyaltyList(false)}>닫기</button> </th>
                    <td colSpan={2}>
                      <table className="write">
                        <colgroup>
                          <col width="30%"></col><col width="20%"></col><col width="20%"></col><col width="30%"></col>
                        </colgroup>
                        <thead>
                          <tr>
                            <th style={{paddingLeft:"10px",textAlign:"left"}}>로얄티종류</th>
                            <th style={{paddingLeft:"10px",textAlign:"left"}}>로얄티명</th>
                            <th style={{paddingLeft:"10px",textAlign:"left"}}>원생명</th>
                            <th style={{paddingLeft:"10px",textAlign:"left"}}>로열티</th>
                          </tr>
                        </thead>
                        <tbody>
                          {varSettlementRoyaltyList.map((royaltys,i)=>(
                            <tr key={'royaltys_'+i}>
                              <td>{royaltys.stl_vs_idx===1?"마마몽떼":"플라이"}</td>
                              <td>{royaltys.ry_name}</td>
                              <td>{royaltys.ch_name}</td>
                              <td>{addThousandPoint(royaltys.stl_price)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table> 
                    </td>
                  </tr>
                }
                <tr>
                  <th>수시 로열티 <button onClick={e=>onAddSettlementLineHandler(e)}>추가</button></th>
                  <td colSpan={2}>
                    <table className="write">
                      <colgroup>
                        <col width="15%"></col><col width="20%"></col><col width="10%"></col><col width="15%"></col><col width="20%"></col><col width="20%"></col>
                      </colgroup>
                      <thead>
                        <tr>
                          <th style={{paddingLeft:"0px",textAlign:"center"}}>목록</th>
                          <th style={{paddingLeft:"0px",textAlign:"center"}}>내용</th>
                          <th style={{paddingLeft:"0px",textAlign:"center"}}>수량</th>
                          <th style={{paddingLeft:"0px",textAlign:"center"}}>금액</th>
                          <th style={{paddingLeft:"0px",textAlign:"center"}}>제공일시</th>
                          <th style={{paddingLeft:"0px",textAlign:"center"}}>상세</th>
                        </tr>
                      </thead>
                      <tbody>
                        {varSettlementOtherList.map((settles,i)=>(
                          settles.stl_status === 0?null:
                          <SettlementLines key={'settles_'+i} varSettleData={settles} varSettlementOtherList={varSettlementOtherList} 
                                  setSettlementOtherList={setSettlementOtherList} varSettlementSerious={varSettlementSerious}/>
                        ))}
                      </tbody>
                    </table> 
                  </td>
                </tr>
                <tr>
                  <th>수시 로열티 합계</th>
                  <td><input type="text" name="otherAmount" style={{width:"150px",backgroundColor:"#eee"}} value={addThousandPoint(varSettlementInfo.otherAmount)} disabled/></td>
                  <td></td>
                </tr>
                <tr>
                  <th>정산 총액</th>
                  <td><input type="text" name="totalAmount" style={{width:"150px",backgroundColor:"#eee"}} value={addThousandPoint(varSettlementInfo.totalAmount)} disabled/></td>
                  <td></td>
                </tr>
                {Number(st_idx)===0?null:
                  <tr>
                    <th>입금액</th>
                    <td><input type="text" name="st_income" style={{width:"150px"}} value={addThousandPoint(varSettlementData.st_income)} onChange={e=>onChangeInputHandler(e)} /></td>
                    <td></td>
                  </tr>
                }
                {Number(st_idx)===0?null:
                  <tr>
                    <th>입금일</th>
                    <td>
                      <DatePicker name="st_fdate" className="datepicker" dateFormat="yyyy.MM.dd" selected={varInsMoneyDate} onChange={(date)=>onChangeDateHandler(date)} />
                    </td>
                    <td></td>
                  </tr>
                }
                {Number(st_idx)===0?null:
                  <tr>
                    <th>정산상태</th>
                    <td>
                      <select name="st_status" value={varSettlementData.st_status} style={{width:"120px"}} onChange={(e)=>onChangeInputHandler(e)}>
                        <option value={0}>선택</option>
                        {/* <option value={1}>정산신청</option> */}
                        <option value={2}>정산승인</option>
                        <option value={3}>정산완료</option>
                      </select>
                    </td>
                    <td></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div style={{width:"100%",marginTop:"10px",textAlign:"center"}}>
            <Link to={'/Admin/SettlementList'} className="btn line" style={{width:"100px"}}>목록</Link>&nbsp;
            <button onClick={e=>onUpdateSettlementHandler(e)} className="btn-danger" style={{width:"100px"}}>등록</button>
          </div>
        </div>
    </div>
  );
}
export  default SettlementDetail;